/** @deprecated Import from `@/shared/tokens` — kept for backward compatibility. */
export { brandColors } from '@/shared/tokens/colors';

export const focusRingClassName =
  'focus-border-brand focus:outline-none focus:ring-1 focus:ring-[#00A7C8]';

export const focusRingClassNameStrong =
  'focus:border-transparent focus:outline-none focus:ring-2 focus:ring-[#00A7C8]';

export const selectClassName =
  'form-control h-9 min-h-9 w-full rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm leading-normal text-gray-900 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-[#00A7C8]';

/** Shared height for text inputs in forms (matches Select). */
export const formInputClassName = 'form-control h-9 min-h-9 py-1.5 text-sm leading-normal';

/** Explicit surface for native inputs when OS is in dark appearance. */
export const formControlSurfaceClassName = 'bg-white text-gray-900';

export const focusWithinBrandClassName =
  'focus-within-brand focus-within:outline-none focus-within:ring-1 focus-within:ring-[#00A7C8]';

/** Structural border on cards / panels — gray-300 for clearer edges on gray-100 canvas */
export const borderDefaultClassName = 'border-gray-300';

/** In-card list row dividers */
export const divideSubtleClassName = 'divide-y divide-gray-200';

/** Sidebar / app shell nav item — selected */
export const navItemActiveClassName =
  'nav-item-active flex w-full items-center gap-3 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors';

export const navItemInactiveClassName =
  'flex w-full items-center gap-3 rounded-lg px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50';

/** Sidebar class list (owned / joined) — selected */
export const navClassItemActiveClassName =
  'nav-item-active flex w-full items-center gap-3 rounded-lg px-4 py-2 text-sm font-semibold transition-colors';

export const navClassItemInactiveClassName =
  'flex w-full items-center gap-3 rounded-lg px-4 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50';

/** @deprecated Use navItemActiveClassName */
export const navActiveClassName = 'nav-item-active';

/** Underline tabs (class section nav, payments main tabs, attendance status row) */
export const tabNavActiveClassName =
  'tab-nav-active border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors lg:px-5';

export const tabNavInactiveClassName =
  'tab-nav-inactive border-b-2 px-4 py-2.5 text-sm font-medium transition-colors lg:px-5';

export const tabNavFlexActiveClassName =
  'tab-nav-active flex-1 border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors lg:px-5';

export const tabNavFlexInactiveClassName =
  'tab-nav-inactive flex-1 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors lg:px-5';

/** Secondary in-page filters (pill chips) — teams/students, payment student/category, etc. */
export const filterPillActiveClassName =
  'rounded-full bg-brand-500 px-4 py-1.5 text-sm font-medium text-white transition-colors';

export const filterPillInactiveClassName =
  'rounded-full bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-200';

/** Card section header — title + actions stack on mobile (neutral / drill-down) */
export const panelSectionHeaderClassName =
  'flex flex-col gap-3 border-b border-gray-300 p-4 sm:flex-row sm:items-center sm:justify-between lg:px-6 lg:py-5';

/** Primary card section header — teal tint (class tabs, panel roots) */
export const panelSectionBrandHeaderClassName =
  'class-section-subheader flex flex-col gap-3 border-b p-4 sm:flex-row sm:items-center sm:justify-between lg:px-6 lg:py-5';

/** Action group beside a panel section title */
export const panelSectionActionsClassName =
  'flex w-full flex-wrap items-center gap-2 sm:w-auto sm:gap-3';

/** Bottom padding that respects iOS home indicator (pair with horizontal/top padding) */
export const safeAreaPaddingBottomClassName = 'pb-[calc(1.25rem+env(safe-area-inset-bottom,0px))]';

export const safeAreaPaddingBottomCompactClassName =
  'pb-[calc(1rem+env(safe-area-inset-bottom,0px))]';

/** Conversation list / selectable rows */
export const selectionActiveClassName = 'selection-active border-l-[3px]';

export const selectionInactiveClassName = 'border-l-[3px] border-transparent';

export const calendarDaySelectedClassName =
  'calendar-day-selected flex aspect-square flex-col items-center justify-center rounded-lg border text-sm font-medium transition-all';

/** Solid teal CTA with icon + label (roster, members, behaviour, etc.) */
export const primaryButtonClassName =
  'btn-primary inline-flex h-10 items-center gap-2 rounded-lg px-4 text-sm font-medium transition-colors';

/** Solid teal CTA — medium padding (save, submit in forms) */
export const primaryButtonMdClassName =
  'btn-primary inline-flex h-10 items-center justify-center rounded-lg px-4 text-sm font-medium transition-colors';

/** Solid teal CTA — full width (behaviour save, etc.) */
export const primaryButtonFullClassName =
  'btn-primary inline-flex h-11 w-full items-center justify-center rounded-lg text-sm font-medium transition-colors';

/** Solid teal CTA — compact (create post, calendar nav, inline CTAs) */
export const primaryButtonSmClassName =
  'btn-primary inline-flex h-9 items-center justify-center rounded-lg px-4 text-sm font-medium transition-colors';

/** Alias for ad-hoc anchor/button CTAs that bypass the Button component */
export const compactCtaClassName = primaryButtonSmClassName;

/** Solid teal CTA — icon-only circle */
export const primaryIconButtonClassName =
  'btn-primary flex shrink-0 items-center justify-center rounded-full transition-colors';

/** MyU Prime upgrade CTA — golden gradient */
export const primeButtonClassName =
  'btn-prime inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg px-4 text-sm font-medium transition-all';

/** Compact MyU Prime CTA (sidebar) */
export const primeButtonSmClassName =
  'btn-prime btn-prime-sm flex w-full items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition-all shadow-sm';

/** Teal background for toggles / indicators */
export const brandSolidBgClassName = 'bg-brand-solid';

/** Teal text link (add template, add term, section footers) */
export const brandTextLinkClassName =
  'class-section-action-link text-sm font-semibold transition-colors lg:text-base';

/** Strong teal body emphasis — readable on white (matches attendance stat prominence) */
export const brandTextStrongClassName = 'text-brand-strong';

/** Teal emphasis text (counts, labels, read receipts) */
export const brandTextEmphasisClassName = 'text-brand-emphasis';

/** Teal muted text (secondary links) */
export const brandTextMutedClassName = 'text-brand-muted';

/** Section metric circle — matches attendance progress ring footprint (64px) */
export const sectionMetricBadgeClassName =
  'period-badge flex h-16 w-16 shrink-0 items-center justify-center rounded-full text-base font-semibold tabular-nums';

/** Wider metric badge for short labels like "1 st" in grades */
export const sectionMetricBadgeWideClassName =
  'period-badge flex h-16 min-w-16 shrink-0 items-center justify-center rounded-full px-2.5 text-sm font-semibold tabular-nums';

/** Metric badge with centered icon (non-period calendar events) */
export const sectionMetricBadgeIconClassName =
  'period-badge period-badge-icon flex h-16 w-16 shrink-0 items-center justify-center rounded-full';

/** Metric badge for custom calendar events — amber palette, distinct from period teal */
export const sectionEventBadgeIconClassName =
  'event-badge flex h-16 w-16 shrink-0 items-center justify-center rounded-full';

/** Person initials in class section lists — same footprint as metric badges */
export const listPersonBadgeClassName =
  'list-person-badge flex h-16 w-16 shrink-0 items-center justify-center rounded-full text-base font-semibold';

/** Person initials in attendance roster rows — compact footprint */
export const attendancePersonBadgeClassName =
  'list-person-badge flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold';

/** Attendance status pill buttons (present, late, excused, absent) */
export const attendanceStatusButtonClassName =
  'inline-flex min-h-8 items-center justify-center rounded px-2.5 text-xs font-semibold transition-colors';

/** Interactive list row in class tab sections */
export const classSectionListRowClassName =
  'flex w-full cursor-pointer items-center gap-4 p-4 text-left transition-colors hover:bg-gray-50 lg:px-6 lg:py-5';

/** Static list row (non-button wrapper) */
export const classSectionListRowStaticClassName =
  'flex items-center gap-4 p-4 transition-colors hover:bg-gray-50 lg:px-6 lg:py-5';

/** Primary label in class section list rows */
export const classSectionRowTitleClassName =
  'text-base font-semibold text-gray-900 lg:text-[1.0625rem]';

/** Secondary line in class section list rows */
export const classSectionRowMetaClassName = 'text-sm text-gray-600 lg:text-[0.9375rem]';

/** Prominent teal metadata (counts, schedules, grades) — attendance-style emphasis */
export const classSectionAccentMetaClassName =
  'class-section-accent-meta text-sm font-medium lg:text-[0.9375rem]';

/** In-card nested subsection title bar (e.g. Attendance History, Student Grades) */
export const classSectionSubheaderClassName =
  'border-b border-gray-200 bg-white p-4 text-base font-semibold text-gray-900 lg:px-6 lg:py-4 lg:text-[1.0625rem]';

/** Footer row for add/upload actions inside class section cards */
export const classSectionPanelFooterClassName = 'border-t border-gray-300 p-4 lg:px-6 lg:py-5';

/** Section status — success (submitted, complete) */
export const sectionStatSuccessClassName = 'section-stat-success font-semibold';

/** Section status — pending / incomplete */
export const sectionStatWarningClassName = 'section-stat-warning font-semibold';

/** Section status — informational counts (teal, like attendance present) */
export const sectionStatInfoClassName = 'section-stat-info font-semibold';

/** Attendance history stat line colors — higher contrast than brand teal on white */
export const attendanceStatPresentClassName = 'attendance-stat-present font-medium';
export const attendanceStatLateClassName = 'attendance-stat-late font-medium';
export const attendanceStatAbsentClassName = 'attendance-stat-absent font-medium';
export const attendanceStatExcusedClassName = 'attendance-stat-excused font-medium';
export const attendanceStatTotalClassName = 'attendance-stat-total font-medium';

/** @deprecated Use sectionMetricBadgeClassName */
export const periodBadgeClassName = sectionMetricBadgeClassName;

/** @deprecated Use sectionMetricBadgeWideClassName */
export const periodBadgeLgClassName = sectionMetricBadgeWideClassName;

/** Icon tile on auth registration */
export const brandIconTileClassName =
  'bg-brand-light text-brand-emphasis flex h-12 w-12 items-center justify-center rounded-2xl';

export const brandAccentInputClassName = 'accent-brand';

export const brandHoverTextClassName = 'hover-text-brand';

/** Minimum 44×44px tap target for icon-only controls (WCAG / mobile) */
export const iconTouchTargetClassName =
  'touch-target inline-flex shrink-0 items-center justify-center rounded-full transition-colors hover:bg-gray-100';

export const iconTouchTargetSquareClassName =
  'touch-target inline-flex shrink-0 items-center justify-center rounded-lg transition-colors hover:bg-gray-100';

/** Reserve space above fixed mobile bottom nav */
export const mobileShellMainClassName = 'pb-[calc(4rem+env(safe-area-inset-bottom,0px))] lg:pb-0';

/** Full-height panels in mobile landscape */
export const mobileLandscapePanelClassName = 'max-lg:landscape:min-h-0 max-lg:landscape:flex-1';

/** Feed post card shell — matches `Card` elevation on gray-100 canvas */
export const postCardClassName =
  'overflow-hidden rounded-xl border border-gray-300 bg-white shadow';

/** Question / event / pinned header strip */
export const postKindBannerClassName = 'border-b border-brand-200 bg-[#EEF9FB] px-4 py-2.5';

export const postKindBannerLabelClassName =
  'text-xs font-bold uppercase tracking-wide text-brand-strong';

/** Horizontal section divider inside specialty post cards */
export const postCardSectionClassName = 'border-t border-gray-300 px-4 py-3 lg:px-5';

/** In-card info panel (due date, teacher chip, event meta) */
export const postCardInsetPanelClassName = 'rounded-xl border border-gray-300 bg-gray-50 p-3';

/** Compact single-line schedule / due-date row inside specialty post cards */
export const postCardInsetPanelCompactClassName =
  'min-h-[2.25rem] rounded-xl border border-gray-300 bg-gray-50 px-3 py-2';

/** Primary post / caption body (UGC text). Pair with `dir="auto"` on the element. */
export const postCaptionClassName =
  'whitespace-pre-wrap text-start text-sm leading-relaxed text-gray-800 lg:text-base';

/** Secondary post body (question description, comments) */
export const postBodyMutedClassName =
  'whitespace-pre-wrap text-start text-sm leading-relaxed text-gray-700 lg:text-base';

/** Stats row under post actions */
export const postStatsBarClassName =
  'flex items-center justify-between border-t border-gray-200 px-4 py-2 text-sm text-gray-500';

/** Action row (like / comment) at bottom of a post */
export const postActionsBarClassName = 'border-t border-gray-200 p-4';
